import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

export default function SocialMedia(props){
    return(
        <div className="socialMedia">
            <ul>
                <li><a href="/"><FontAwesomeIcon icon={faInstagram} /></a></li>
                <li><a href="/"><FontAwesomeIcon icon={faTwitter} /></a></li>
                <li><a href="/"><FontAwesomeIcon icon={faTelegramPlane} /></a></li>
                <li><a href="/"><FontAwesomeIcon icon={faLinkedinIn} /></a></li>
            </ul>
        </div>
    )
}